<template>
  <div id="main">
    <!--上部分-->
    <div class="col-xs-12 col-sm-12 grid_div" id="grid_top_div">
      <div id="top_title">
        鄂尔多斯党校管理系统
      </div>
      <div id="tool">
        <!--<div id="setting">
          <img src="../assets/img/top/setting.png"/>
          <span>设置</span>
        </div>-->
        <router-link to="/cateringRecord">
        <div id="exit">
          <span>返回</span>
        </div>
        </router-link>
      </div>
    </div>
    <div  class="col-xs-1 col-sm-1"></div>

    <div class="col-xs-10 col-sm-10 notintime"  v-if="cateringType == 0">
      不在餐饮时段，请稍等！
    </div>
    <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div" v-else>
      <div  class="col-xs-6 col-sm-6 qrcode">
        <div class="title">{{thisDate|formatDate("M月d日")}}{{catering_type[cateringType]}}，请扫码就餐</div>
        <div id="qrcodeDiv"></div>
      </div>
      <div  class="col-xs-6 col-sm-6 record">
        <div class="title">
          {{searchFlag?"查询":"今日"}}{{catering_type[cateringType]}}<span>{{cateringCount}}</span>人已就餐
          <div class="btn btn_option btn_square" @click="addRecord()">
          就餐登记
          </div>
        </div>
        <table class="table table-striped table-bordered">
          <thead>
          <tr>
            <th>
              <div class="searcharea">
                <input class="form-control" placeholder="姓名"  v-model="searchParams.userName"/>
                <button type="button" class="btn btn-default btn_option" @click="initDataList()">查询</button>
              </div>
            </th>
            <th width="40%">时间</th>
          </tr>
          </thead>
          <tbody>
          <!--<tr v-for="(d, index) in studentList" :key="index">
            <td>{{index + 1}}</td>
            <td>{{d.userName}}</td>
            <td>{{d.etime}}</td>
          </tr>-->
          <tr v-for="(d, index) in dataList" :key="index">
            <td class="nametd">{{d.userName}}</td>
            <td>
              {{d.etime?d.etime.substring(10, 19):""}}<br/>{{catering_mode[d.mode]}}
              <div class="delete_pic" @click="deleteRecord(d.id)" v-if="d.mode==2"></div>
            </td>
          </tr>
          </tbody>
        </table>
        <page-view v-bind="searchParams"></page-view>
      </div>


    </div>

    <div  class="col-xs-1 col-sm-1"></div>
    <div class="modal fade" id="addRecordModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content modal-work-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4 class="modal-title" id="myModalLabel">
              就餐登记
            </h4>
          </div>
          <div class="modal-body modal_work_trainingManage">
            <div>
              <input type="text"  name="menuDate" class="form-control" id="menuDate" placeholder="输入姓名或电话" v-model="queryName"
                     @keyup.enter="keyup(0)" @keyup.up="keyup(-1)" @keyup.down="keyup(1)"  @keyup="loadQueryInputDataWhenAdd($event)" @focus="loadQueryInputDataWhenAdd()" autocomplete="off"/>
            </div>
            <div id="students_div">
              <option v-for="(queryData, index) in queryInputDataArr" :key="index" :value="queryData.userName" :class="index != selectedIndex||'selected'"
                      @click="chooseData(queryData)">{{queryData.name}}-{{queryData.clazzName}}</option>
            </div>
            <div>
              <table class="table table-striped table-bordered">

                <tbody>
                <tr>
                  <td width="30%">姓名</td>
                  <td>{{postData.userName}}</td>
                </tr>
                <tr>
                  <td >班级</td>
                  <td>{{postData.className}}</td>
                </tr>
                </tbody>
              </table>

            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" @click="saveRecord()">确定</button>
            <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from "../main";
  import {getContentSize} from './mainView';
  import dictionaryData from '../json/dictionary';
  import QRCode from 'qrcodejs2';
  import pageView from './pageView';
  export default {
    name: "cateringQrcode",
    components:{pageView},
    data() {
      return {
        clazzId: this.$store.state.clazzId,
        publishStatus: this.$store.state.publishStatus,
        classStatus: this.$store.state.classStatus,
        thisDate: new Date(),
        catering_type:dictionaryData.catering_type,
        cateringType: 0,
        catering_mode:{
          "1":"扫码",
          "2":"登记"
        },
        dataList:[],
        cateringCount: 0,
        searchStudent:"",
        timeDuring:{//各餐段区间
          "1": "06:00-10:00",
          "2": "11:00-14:30",
          "4": "17:00-20:00",
          // "1": "06:00-10:00",
          // "2": "10:00-14:30",
          // "4": "15:28-20:00",
        },
        qrcode:null,
        qrValue:"",
        queryName: "",
        postData:{
          userName:"",
          userId:"",
          className:"",
          mode:"",
          flag:"",
          type:""
        },
        queryInputDataArr:[],
        selectedIndex: -1,
        searchParams: {
          userName:'',
          type:"",
          etime:"",
          all: 0,
          rows: 10,
          page:1
        },
        searchFlag:false
      }
    },
    filters: {
      formatDate(value, fmt){
        if(!value) return;
        var o = {
          'M+': value.getMonth() + 1, // 月份
          'd+': value.getDate(), // 日
          'h+': value.getHours(), // 小时
          'm+': value.getMinutes(), // 分
          's+': value.getSeconds(), // 秒
          'q+': Math.floor((value.getMonth() + 3) / 3), // 季度
          'S': value.getMilliseconds() // 毫秒
        }
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (value.getFullYear() + '').substr(4 - RegExp.$1.length))
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))

        }
        return fmt
      },
      formatType(value){
        let this_ = this;
        if(dictionaryData.clazz_type && value){
          value = dictionaryData.clazz_type[value];
        }
        return value;
      },

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        this_.closeModal();
        this_.init();
        this_.initWebsocket();
        setInterval(function () {
          this_.init();
        }, 60*1000);
        this_.searchParams.page = 1;
        this_.searchParams.pageCallback = this_.initDataList;
      });
    },
    methods: {
      /**
       * 初始化当页面参数，且定时刷新
       */
      init(){
        this.thisDate = new Date();
        let date = this.$options.filters["formatDate"](this.thisDate, "yyyyMMdd");
        let curDateTime = Number(this.$options.filters["formatDate"](this.thisDate, "yyyyMMddhhmm"));
        for(let d in this.timeDuring){//当前时间区段
          let times = this.timeDuring[d].replaceAll(":","").split("-");
          let start = Number(date+ times[0]), end = Number(date+ times[1]);
          if (curDateTime>=start && curDateTime<=end){
            this.cateringType = d;
            this.initQrcode();
            this.initDataList();
            return;
          }
        }
        this.cateringType = 0;
      },

      initQrcode(){
        let this_ = this;
        let date = this.$options.filters["formatDate"](this.thisDate, "yyyy-MM-dd");
        let qrValue = "ws.cat:" + date + "|" +  this.cateringType;// 二维码内容
        if(qrValue == this_.qrValue)
          return;
        this_.qrValue = qrValue;
        $("#qrcodeDiv").html("");
        setTimeout(function () {
          this_.qrcode = new QRCode('qrcodeDiv', {
            width: 600,
            height: 600,
            text: qrValue
          });
          this_.qrcode._el.title = "";
        })
      },

      initDataList(pageParams){
        let this_ = this;
        if(pageParams)
          Object.assign(this_.searchParams, pageParams);

        let _searchParams = {};
        Object.assign(_searchParams, this_.searchParams);
        let date = this.$options.filters["formatDate"](this.thisDate, "yyyy-MM-dd hh:mm:ss");
        _searchParams.type = this_.cateringType;
        _searchParams.etime = date;
        if(_searchParams.userName){
          this_.searchFlag = true;
        }else{
          this_.searchFlag = false;
        }
        delete _searchParams.pageCallback;//提交前删除回调
        schoolAxios({
          method: 'get',
          url: 'cateringRecord/findPage',
          params: _searchParams
        }).then(function (resp) {
          if(resp.data.success){
            // console.info(this_.userId);
            this_.dataList = resp.data.list;
            this_.cateringCount = resp.data.totalSize;
            this_.searchParams.all = resp.data.totalPage;
            this_.searchParams.page = 1;
          }
        });
      },
      addRecord(){
        this.queryName = "";
        $("#addRecordModal").modal("show");
      },
      keyup(opt){
        let this_ = this;
        if(opt == 0){
          if(this_.queryName){
            if(this_.selectedIndex >= 0 && this_.queryInputDataArr && this_.selectedIndex < this_.queryInputDataArr.length) {
              let d = this_.queryInputDataArr[this_.selectedIndex];
              this_.selectedIndex = -1;
              this_.chooseData(d);
              $("#students_div").hide();
            }
          }
          return;
        }

        if(this_.queryInputDataArr && this_.queryInputDataArr.length>0){
          if(opt == -1){
            if(this_.selectedIndex <= 0) return;
            else this_.selectedIndex -= 1;
          }else if(opt == 1){
            if(this_.selectedIndex == this_.queryInputDataArr.length-1) return;
            else this_.selectedIndex += 1;
          }
          this_.queryName = this_.queryInputDataArr[this_.selectedIndex].name;
        }
      },
      /**
       * 联想查询班主任信息-add
       */
      loadQueryInputDataWhenAdd(event){
        let this_ = this;

        if(event && (event.keyCode == 13 //回车
          ||event.keyCode == 38//上键
          ||event.keyCode == 40 ))//下键
          return;
        if (this_.queryName != "") {
          //后台查询数据赋值
          schoolAxios({
            method: 'get',
            url: 'cateringRecord/cateringStudents',
            params: {
              'userName': this_.queryName
            }
          }).then(function (resp) {
            let data = resp.data;
            if (data.success) {
              this_.queryInputDataArr = data.list;
              $("#students_div").show();
            }
          });
        } else {
          this_.queryInputDataArr = [];
          $("#students_div").hide();
          this_.selectedIndex = -1;
          this_.postData = {
            userName:"",
            userId:"",
            className:"",
            mode:"",
            flag:"",
            type:"",
          };
        }
      },
      chooseData(d){
        let this_ = this;
        this_.queryName = d.name;
        this_.postData.userName=d.name;
        this_.postData.userId=d.userId;
        this_.postData.className=d.clazzName;
        this_.postData.mode="2";
        this_.postData.flag="1";
        this_.postData.type=this_.cateringType;
        $("#students_div").hide();
      },
      saveRecord(){
        let this_ = this;
        if(!this_.postData || !this_.postData.userId){
          "未选择数据".showMessage();
          return;
        }
        schoolAxios({
          method: "post",
          url: "cateringRecord/add",
          data: this_.postData
        }).then(function (resp) {
          let data = resp.data;
          if (data.success) {
            $("#addRecordModal").modal("hide");
            this_.initDataList();
            this_.queryName = "";
            this_.postData = {};
          } else {
            (data.message||"保存失败").showMessage();
          }
        });
      },
      deleteRecord(id){
        let this_ = this;
        "确定删除".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'cateringRecord/delete/'+id,
            params: {}
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              // "删除成功".showMessage();
              this_.initDataList();
            }else{
              (data.message||"删除失败").showMessage();
            }
          })
        })
      },
      /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        $("#addRecordModal").on('hide.bs.modal', function () {
          this_.queryName = "";
          this_.postData = {
            userName:"",
            userId:"",
            className:"",
            mode:"",
            flag:"",
            type:"",
          };
          this_.selectedIndex = -1;
        });
      },
      initWebsocket () {
        let this_ = this;
        this_.$root.$on('SOCKET_ONMESSAGE', function (message) {
          if(message){
            if('refresh' == message.viewParams){
              this_.initDataList();
            }
          }

        })
        this.$connect(this.$store.state.websocketBase + 'websocket/command/' + this.$store.state.userId + "?access_token=" + this.$store.state.access_token )
      },


    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  #grid_top_div {
    height: 60px;
    background-color: #db261b;
  }
  #top_title {
    font-size: 20px;
    color: #ffffff;
    padding-top: 16px;
    padding-left: 40px;
    width: 250px;
  }
  #tool {
    position: absolute;
    top: 16px;
    right: 0px;
  }
  #tool div {
    float: left;
    margin-right: 50px;
    font-size: 15px;
    color: #ffffff;
    line-height: 20px;
  }
  .title{
    font-size: 40px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  .btn_square{
    width: 70px;
    height: 70px;
    font-size: 20px;
    white-space: normal;
  }
  #qrcodeDiv img{
    width: 90%!important;
    margin: auto!important;
  }
  .record .title span{
    color: #CC0000;
    font-size: 1.5em;
  }
  .record table th,.record table td{
    border-left: 0;
    border-right: 0;
    padding-left: 20px;
  }
  .record table td.nametd{
    height: 60px;
    line-height: 60px;
    font-size: 36px;
  }
  .notintime{
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    padding: 100px 0;
  }
  .searcharea{
    display: inline-block;
    width: 220px;
  }
  .searcharea .form-control{
    width: 120px;
    display: inline-block;
  }
  #students_div {
    position: absolute;
    left: 26px;
    width: 84%;
    border: 1px grey solid;
    background-color: white;
    display: none;
    z-index: 1000;
  }
  #students_div option {
    height: 30px;
    line-height: 30px;
    text-align: left;
  }
  #students_div option:hover , #students_div .selected{
    background-color: grey!important;
  }
  .delete_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/trainingManage/delete_mouseOver.png");
    background-size: 100% 100%;
    float: right;
    cursor: pointer;
    margin-right: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/cateringQrcode.vue